import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter weekly-wrapper ms-md-4" }
const _hoisted_2 = {
  key: 0,
  class: "date-navigation d-flex mx-auto mx-md-0",
  id: "weekly-date"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left date-change-icon cursor-pointer" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "mx-2 formatted-date" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right date-change-icon cursor-pointer" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.formattedDateRange)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: "cursor-pointer px-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backwardNavigation()))
            }, _hoisted_4)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formattedDateRange), 1 /* TEXT */),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: "cursor-pointer px-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.forwardNavigation()))
            }, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}